module.exports = __webpack_public_path__ + "media/assets/icons/info-with-circle-d869f68ad968ec80fa31a9d217a4025e.svg";